import React from 'react'
import Loader from 'react-loader-spinner'
import { withRouter } from 'react-router-dom'
import { imageAddress, pathMaker, translate } from '../utils/useful';
import ButtonAnimated from './buttons/ButtonAnimated';
import PermissionDenied from './PermissionDenied';

class PageStatusViewer extends React.Component {



    state = {
        timer: 4,
    }

    startTimer() {
        if (!this.timer) {
            this.timer = setInterval(this.checkTimer, 1000);
        }
    }

    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    }

    checkTimer = () => {
        if (this.state.timer > 0) {
            this.setState({ timer: this.state.timer - 1 })
        } else {
            let search = this.props.location.search;
            let params = new URLSearchParams(search);
            let ref = params.get('ref');
            if (ref && ref !== '') {
                // console.log(ref)
                if (this.timer) {
                    clearInterval(this.timer)
                }
                this.props.history.push(ref)
            } else {
                if (this.timer) {
                    clearInterval(this.timer)
                }
                this.props.history.push(pathMaker('/'))
            }
        }
    }


    render() {
        if (!this.props.status) {

            return (
                <div className="mt-5 text-center w-100">
                    {this.props.isLoading == null || this.props.isLoading == true && (
                        <Loader
                            type={this.props.type ?? "Oval"}
                            color={this.props.color ?? "#789"}
                            height={this.props.width ?? 50}
                            width={this.props.height ?? 50}
                        />
                    )}
                </div>
            )
        }

        if (this.props.status == 200) {
            return this.props.children

        }


        if (this.props.status == 401) {
            return (

                <PermissionDenied applet={this.props.applet} />
            )
        }


        if (this.props.status == 404) {
            return (
                <div className="w-100 mt-5 text-center">
                    <h3 className=" text-ultra-big m-0">{translate('Page Not Found')}</h3>
                    <h3 className=" text-mega-big m-0">404</h3>
                </div>
            )
        }

    }
}

export default withRouter(PageStatusViewer);